"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var withFormSnippet = function withFormSnippet(_a) {
  var nodeKeys = _a.nodeKeys,
      defaultData = _a.defaultData,
      snippetOptions = _a.snippetOptions;
  return core_1.withSidecarNodes(lodash_1.flowRight(core_1.withNodeKey(nodeKeys), core_1.withNode, core_1.withNodeDataHandlers(defaultData), core_1.withEditFormSnippet(snippetOptions), core_1.withoutProps('setComponentData'), core_1.withData));
};

exports.default = withFormSnippet;